import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useClientAuth } from "@/context/ClientAuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setClient } = useClientAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (!sessionId) { navigate("/", { replace: true }); return; }
      try {
        const { data } = await api.post("/client-auth/google-session", { session_id: sessionId });
        setClient(data);
        window.history.replaceState(null, "", "/account");
        navigate("/account", { replace: true });
      } catch {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setClient]);

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center">
      <Loader2 className="animate-spin text-[#C5B382]" />
    </div>
  );
}
